export const TITLE = "Passenger Electric Auto Price in India 2026 - Turno";
export const FAQ_HEAD_TEXT = "Frequently Asked Questions on Electric Auto Rickshaw";
export const META_CONTENT = [
  {
    name: "description",
    content:
      "Buy electric passenger vehicles & EV auto rickshaws online. Range up to 178km, cost ₹40/100km. EMI from ₹10,324/month. Mahindra Treo, Piaggio E-City models available. Zero emissions, low running costs. Book test drive with easy financing options.",
  },
  {
    name: "keywords",
    content:
      "Electric Passenger Vehicles, electric auto rickshaw, electric passenger auto, electric auto online, electric auto price, electric auto EMI, electric auto financing, electric auto test drive, Mahindra Treo, Piaggio E-City, electric auto range, electric auto cost, electric auto emissions, electric auto running cost, electric auto booking, electric auto dealer, Turno electric auto, electric auto India, electric auto specifications, electric auto features",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/passenger",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/passenger",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Passenger Electric Auto Price in India 2026 - Turno",
  },
  {
    property: "og:description",
    content:
      "Buy electric passenger vehicles & EV auto rickshaws online. Range up to 178km, cost ₹40/100km. EMI from ₹10,324/month. Mahindra Treo, Piaggio E-City models available. Zero emissions, low running costs. Book test drive with easy financing options.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Buy electric passenger vehicles & EV auto rickshaws online. Range up to 178km, cost ₹40/100km. EMI from ₹10,324/month. Mahindra Treo, Piaggio E-City models available. Zero emissions, low running costs. Book test drive with easy financing options.",
  },
  {
    name: "twitter:title",
    content: "Passenger Electric Auto Price in India 2026 - Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/passenger",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/passenger";

export const H1_HEADING = "Electric Auto Rickshaw";

export const ATF_CONTENT = {
  text: [
    "With increasing air and noise pollution in the Indian cities, the need for a more intelligent, economical, and clean transportation system has never been more evident. Presenting the electric passenger auto rickshaws, a small and powerful three-wheelered vehicle designed for drivers, business owners, and fleet managers who are seeking reduced operating expenses, zero tailpipe emissions, and a business model that is ready for the future.",
    "The transition to electric auto rickshaws is not only desirable, but also unavoidable given the skyrocketing fuel prices and stricter emission norms. Battery autos do not have the clatter of petrol or diesel engine but 'humm' of an electric motor. Not only, it provide smoother operations but also ensure a comfortable journey for your passengers.",
    "With electric passenger auto rickshaws, there is a high prospect of saving thousands of rupees a month on fuel and maintenance. That is how a well-designed passenger electric auto rickshaw works its magic. Turno offers a wide range of electric auto rickshaws for different needs of different kinds of business requirements. We also provide PAN-India assistance, three-wheeler financing, and a buy-back guarantee. You can find a battery auto that suits your route, and a battery auto price that suits your budget, along with your goals, whether you're starting your own autorickshaw business or upgrading the fleet.",
  ],
};

export const PRICING_TABLE_HEADING = "Electric Auto Price Table";

export const PRICING_TABLE_COLUMNS = [
  { key: "model", label: "Electric Auto Model" },
  { key: "topRange", label: "Top Range" },
  { key: "gvw", label: "Gross Vehicle Weight" },
  { key: "topSpeed", label: "Top Speed" },
  { key: "priceRange", label: "Ex-Showroom Price" },
];

export const PRICING_TABLE_DATA = [
  {
    model: "Mahindra Treo Plus Auto",
    topRange: "150 km",
    gvw: "720 kg",
    topSpeed: "55 km/h",
    priceRange: "3.85L",
    link: "/electric-commercial-vehicles/Mahindra/treo-plus",
  },
  {
    model: "Piaggio E-City FX Auto",
    topRange: "110 km",
    gvw: "713 kg",
    topSpeed: "45 km/h",
    priceRange: "3.20L",
    link: "/electric-commercial-vehicles/Piaggio/ape-e-city-fx",
  },
  {
    model: "Bajaj RE E TEC 9.0",
    topRange: "178 km",
    gvw: "708 kg",
    topSpeed: "45 km/h",
    priceRange: "3.65L",
    link: "/electric-commercial-vehicles/Bajaj/re-e-tec",
  },
  {
    model: "Montra Electric Super Auto",
    topRange: "160 km",
    gvw: "749 kg",
    topSpeed: "55 km/h",
    priceRange: "3.76L",
    link: "/electric-commercial-vehicles/Montra/super-auto",
  },
];

export const SEO_FOOTER_CONTENT = [
  {
    heading: "About Electric Passenger Vehicles",
    paragraphs: [
      "Electric passenger auto rickshaws are three-wheeled electric vehicles engineered to carry a driver and typically up to three or four passengers. These three-wheelers do not use regular petrol, diesel or CNG fuel but rely on electricity to drive the electric motor.",
      "The electricity to drive the electric passenger auto is stored in lithium-ion batteries. A motor controller manages the power output of the electric motor and can be variated by the driver through throttle inputs. The electric powertrain used in passenger autos do not produce any tailpipe emissions.",
      "Unlike the traditional petrol, diesel or CNG autos, the running costs are minimal and scope of maintenance is reduced by a huge margin. These vehicles are designed for dense urban traffic, frequent stops and short-to-mid range operations, making them ideal for intra-city commutes, ride-hailing applications and last-mile connectivity.",
      "The best elements of electric passenger auto rickshaws are their lower total cost of ownership (TCO), smoother ride, and eligibility for numerous incentives. These factors are making them more and more popular among drivers and fleet owners as markets change. These electric three-wheelers are increasingly being referred to as \"battery autos,\" highlighting their primary distinction, that is, the on-board battery pack, as opposed to an internal combustion engine.",
    ],
  },
  {
    heading: "Electric Auto Price in India 2026",
    paragraphs: [
      "There are a number of electric auto models available in the market in 2026. Each has a different battery size, range, reputation, seating capacity and warranty. The electric auto price starts from ₹3.2 lakhs (ex-showroom) and goes upward based on the specifications.",
      "Here are some factors that influence the electric auto price:",
    ],
    list: [
      {
        label: "Battery capacity",
        text: "Electric auto rickshaw prices are decided by the size of their battery. As a higher capacity battery leads to higher cost but also provides longer range. For example, an electric rickshaw with 11.5 kWh battery will provide longer range than a 8.5 kWh battery but will also cost more. Battery auto price upfront may be slightly higher, but saves big in the long run",
      },
      {
        label: "Manufacturer & brand",
        text: "Premium electric rickshaw brands command higher price, better build quality and longer warranties.",
      },
      {
        label: "Subsidies and incentives",
        text: "Subsidies and incentives on electric autos completely depend on the government policies in your state. If you qualify for the incentives, the auto's price will reduce significantly.",
      },
      {
        label: "Weight / GVW and seating configuration",
        text: "Auto models with higher GVW (Gross Vehicle Weight) and more seating tend to cost a bit more but also offer higher revenue-earning potential.",
      },
      {
        label: "Financing and resale value",
        text: "Multi-brand electric auto platforms like Turno offer financing and buy-back guarantees which influence effective running cost.",
      },
    ],
    additionalParagraphs: [
      "The cost of an electric auto seems to be on a higher side but when you tally up the savings on fuel, maintenance, noise, downtime, etc., the extra cost will easily be offset within months of operation.",
    ],
  },
  {
    heading: "Top Electric Passenger Auto Rickshaws in India",
    paragraphs: [
      "Here are some of the most reliable and high-performing electric passenger auto rickshaws available in India today. Each model brings a balance of range, efficiency, and long-term value for both independent drivers and fleet owners.",
    ],
    subSections: [
      {
        heading: "Mahindra Treo Plus Auto",
        link: "/electric-commercial-vehicles/Mahindra/treo-plus",
        paragraphs: [
          "Mahindra Treo is a trusted name in the Indian electric auto segment. It provides a range of 150 km and a maximum speed of 55 km/h. The running cost of Treo auto hovers around ₹40 per 100 km and offers a refined ride quality.",
        ],
      },
      {
        heading: "Piaggio E-City FX Auto",
        link: "/electric-commercial-vehicles/Piaggio/ape-e-city-fx",
        paragraphs: [
          "Piaggio's electric city auto delivers a practical and budget-friendly experience. It comes with a max range of 110 km and a top speed of 45 km/h. Its low running cost of ₹39 per 100 km makes it an affordable option for city drivers looking to enter the EV segment.",
        ],
      },
      {
        heading: "Bajaj RE E TEC 9.0",
        link: "/electric-commercial-vehicles/Bajaj/re-e-tec",
        paragraphs: [
          "Bajaj brings its trusted engineering into the electric auto space with the RE E TEC 9.0. The range of RE E TEC is impressive at 178 km in a single charge. It gets a top speed of 45 km/h and low ₹40 per 100 km running cost.",
        ],
      },
      {
        heading: "Montra Electric Super Auto",
        link: "/electric-commercial-vehicles/Montra/super-auto",
        paragraphs: [
          "Montra is a premium electric passenger auto rickshaw brand. Its Super Auto model offers a modern take on the classic auto. It provides a range of 160 km on a single charge with a top speed of 55 km/h.",
        ],
      },
    ],
    additionalParagraphs: [
      "At Turno, we are proud of being a Multibrand EV platform in India and offer all of these electric auto models under one roof. This will help you make selection, financing, and after-sale support easier all at one place. The electric auto rickshaws guarantee that you stay ahead of the growing trend towards profitability, clean urban mobility, increased mileage, reduced cost per km, or passenger comfort.",
      "We'll quickly update this page to reflect all new models and upgraded variants as our model lineup grows, making it easier than ever to choose the best electric passenger car for your company. You can find all the most recent models, updated prices, and important specifications in one location.",
    ],
  },
  {
    heading: "How to Select the Best Passenger Electric Auto",
    paragraphs: [
      "Selecting the right electric auto rickshaw for your operation deserves careful thought across multiple parameters. Here's a guide to help you decide:",
    ],
    listType: "ordered",
    list: [
      {
        label: "1. Seating & Cabin Comfort",
        text: "Verify the battery auto's legroom, headroom, ingress/egress, and the number of passengers it can comfortably accommodate (the driver plus three or more). Customers are more likely to prefer and pay more for a model that offers a better passenger experience.",
      },
      {
        label: "2. Battery and Range",
        text: "Consider your use-case when evaluating the battery's certified range per charge and capacity (in kWh). A greater range is essential if you're working long shifts without time to recharge. Battery auto prices also vary, ensuring you find one that fits your budget.",
      },
      {
        label: "3. Charging & Infrastructure",
        text: "How much time does it take to charge the car? Is it possible to charge overnight and be prepared for the run the following day? Does fast charging or swapping work in your area?",
      },
      {
        label: "4. Weight / GVW and Payload",
        text: "How much actual payload, including passengers, luggage and the driver, can the electric auto carry. Understand the Gross Vehicle Weight (GVW) and kerb weight of the electric rickshaw or electric tempo. Profitability is impacted by lower GVW limits.",
      },
      {
        label: "5. Running Cost & Maintenance",
        text: "Factor in savings on fuel (electricity vs petrol/CNG), fewer moving parts, less frequent servicing and longer lifespan. You can also ask about the warranty on the auto, battery and the motor.",
      },
      {
        label: "6. Resale Value and Financing",
        text: "Platforms like Turno offer structured loans and buy-back guarantees that protect your investment. A strong resale market helps you improve your cash-flow and lowers the business risk.",
      },
      {
        label: "7. Brand, Support & Service Network",
        text: "Go with a brand or platform that offers spares, trained service centres and reliability. It is important because downtime causes essential revenue-loss.",
      },
      {
        label: "8. Pricing and Incentives",
        text: "At Turno, you can easily compare ex-showroom electric tempo prices, check how much subsidy you're eligible for. Understand whether financing is available and what running cost per km you can expect in real-world driving conditions. Another important thing to take into account is the pay-back period which you can calculate with Turno.",
      },
    ],
    additionalParagraphs: [
      "By working through these factors, you can select a passenger electric auto, or electric tempo that aligns with your routes, revenue expectations and charging realities, instead of picking solely by price or brand.",
    ],
  },
  {
    heading: "Benefits of Choosing Turno for Passenger Electric Auto",
    paragraphs: [
      "When you decide to invest in an electric passenger auto rickshaw, partnering with the right marketplace matters. Here's why Turno stands out:",
    ],
    list: [
      {
        label: "Multi-brand Platform",
        text: "Turno's multibrand platform allows you to compare models (battery size, range, GVW, and cost) side by side by bringing together leading battery tempo manufacturers in one location.",
      },
      {
        label: "Clear Pricing & Financing",
        text: "Turno makes it simpler to purchase an electric car without requiring a sizable down payment by providing low-interest financing and displaying a variety of electric car pricing options.",
      },
      {
        label: "Complete Support",
        text: "Turno reduces the risk of buying a passenger electric car by offering test drives, doorstep delivery, and a buy-back guarantee.",
      },
      {
        label: "Reduced Operating Costs",
        text: "Turno advocates for the very real savings in operating costs, such as lower daily energy expenditures, less maintenance, and reliable operation.",
      },
      {
        label: "Fleet & Resale Options",
        text: "Turno's platform offers scalability, service-network access, and resale opportunities to increase the value of your investment if you're running a number of vehicles, ensuring your electric tempo price for the entire fleet remains under control.",
      },
    ],
    additionalParagraphs: [
      "With Turno, you're not just buying a vehicle, you're partnering with a brand that understands the transition to electric passenger autos, helping you choose wisely, manage financing and keep you on the road profitably.",
    ],
  },
];

export const PASSENGER_FAQS = [
  {
    question: "What is the average electric auto price in India in 2026?",
    answer:
      "The electric auto price in India in 2026 generally starts around ₹3.2 lakh (ex-showroom) and goes up depending on battery size, range, and brand. Models like Mahindra Treo Plus, Piaggio E-City FX, Bajaj RE E TEC 9.0, and Montra Electric Super Auto fall within this range. Your final on-road cost may differ further through state EV subsidies and financing options.",
  },
  {
    question: "How many kilometers does a passenger electric auto run on a full charge?",
    answer:
      "Most electric passenger auto rickshaws provide anywhere between 110 km to 178 km per full charge depending on model and battery capacity. For example, the Bajaj RE E TEC 9.0 offers up to 178 km, while the Piaggio E-City FX runs up to 110 km. Choose your electric auto based on your daily route distance to avoid extended downtime.",
  },
  {
    question: "What is the running cost of an electric auto compared to petrol or CNG autos?",
    answer:
      "Running an electric auto typically costs ₹39 to ₹40 per 100 km, which is significantly cheaper than petrol or CNG, where costs can go over ₹250 to ₹350 per 100 km. This huge gap helps drivers save thousands of rupees every month, making electric autos far more profitable for daily use.",
  },
  {
    question: "How long does it take to charge an electric passenger auto?",
    answer:
      "Most passenger electric autos charge fully in 3.5 to 5 hours using a standard charger. Drivers generally plug in overnight and start the day with a full battery. If you operate longer shifts, choose a model with higher range (150–178 km) to avoid multiple mid-day charging breaks.",
  },
  {
    question: "Which is the best electric passenger auto rickshaw for long city routes?",
    answer:
      "For longer routes or full-day city operations, models with higher range like the Bajaj RE E TEC 9.0 (178 km) or Montra Electric Super Auto (160 km) are excellent options. They reduce charging frequency and ensure you don't lose income due to multiple battery charging downtimes.",
  },
  {
    question: "Is an electric passenger auto suitable for hilly or semi-urban areas?",
    answer:
      "Yes, most modern battery autos come with strong torque output, making them capable of handling inclines and mixed terrain. However, choosing a model with higher motor performance and stronger build, such as Mahindra Treo Plus or Montra Super Auto, ensures smoother performance on hilly routes or uneven roads.",
  },
  {
    question: "Which brand provides the most reliable support for electric autos in India?",
    answer:
      "Multi-branded platforms like Turno offer a wide range of battery autos, financing, servicing support, and even buy-back guarantees. This makes ownership easier and safer, especially for first-time EV buyers. You get updated model options, transparent electric auto rickshaw price details, and long-term assistance in one place.",
  },
];

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Passenger Electric Auto" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Passenger Electric Auto",
      item: VEHICLE_LINK,
    },
  ],
};